import { create, ZoidComponent } from 'zoid/dist/zoid.frameworks'
import { commonComponentsProps } from '../common/props'

import defaultLoader from '../common/defaultLoaderTemplate'
import { handleOpenChargebeeCheckout } from '../common/useChargebee'

const cdc: ZoidComponent = create({
  tag: 'mbo-cdc-recommendations',

  url: ({ props }) => import.meta.env.VITE_VUE_URL + '/#/' + (
    props.controllerName === 'AdminCarriers' ? 'recommendations-carrier' : 'recommendations'
  ),

  context: 'iframe',

  dimensions: {
    width: '100%',
    height: '100%',
  },

  autoResize: {
    width: false,
    height: true,
  },

  prerenderTemplate: defaultLoader,

  props: {
    ...commonComponentsProps,

    handleOpenChargebeeCheckout,
    controllerName: {
      type: 'string',
      required: false,
    },

    initialBannerState: {
      type: 'string',
      required: false,
    },

    registerCloseAccordion: {
      type: 'function',
      required: false,
    },

    registerCloseDepartureSelect: {
      type: 'function',
      required: false,
    },

  },
})

export default cdc
